const IlsIcon = (props) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <rect width="24" height="24" rx="4" fill="var(--general-currency-icon-background)"/>
        <path d="M6 17V6H11.2535C12.3795 6 13.2068 6.26395 13.7356 6.79185C14.2706 7.31339 14.5381 8.09251 14.5381 9.12923V13.9757H13.0171V9.12923C13.0171 8.52501 12.8678 8.07343 12.5692 7.7745C12.2768 7.47557 11.8383 7.32611 11.2535 7.32611H7.51166V17H6ZM18 6V17H12.7465C11.6205 17 10.79 16.7392 10.2551 16.2177C9.72628 15.6962 9.4619 14.9138 9.4619 13.8708V9.02428H10.9829V13.8708C10.9829 15.0729 11.5708 15.6739 12.7465 15.6739H16.479V6H18Z" fill="var(--general-currency-icon-color)"/>
    </svg>
);

export default IlsIcon;
